var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForcastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.6874V19.71H4V4.70996H5.008V17.6431L8.18311 13.0928C8.31111 12.9088 8.544 12.8313 8.75378 12.9034L14.1831 14.7394L17.7867 9.0132L16.4 9.29635C16.128 9.35226 15.8613 9.17371 15.8062 8.89597C15.7511 8.61822 15.9271 8.34949 16.2009 8.29359L18.6507 7.7922C18.8018 7.72186 18.9813 7.72908 19.1307 7.82467C19.1324 7.82467 19.1342 7.82827 19.136 7.83008C19.1431 7.83368 19.1502 7.83729 19.1573 7.8409C19.2693 7.91665 19.3458 8.03207 19.3724 8.16553L19.8507 10.5714C19.9058 10.8474 19.7298 11.1179 19.456 11.1738C19.4222 11.181 19.3884 11.1847 19.3564 11.1847C19.1218 11.1847 18.912 11.0169 18.8622 10.7734L18.624 9.57951L14.8196 15.625C14.6951 15.8233 14.4533 15.9081 14.2347 15.8342L8.78756 13.9928L5.51111 18.6874H19.9982H20Z",
    fill: "",
    stroke: "",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForcastIcon);
export default __webpack_public_path__ + "static/media/forcast-icon.09e146220e13bf9dbacbd1c8fb4eda9b.svg";
export { ForwardRef as ReactComponent };